import { Type, type Static } from "@sinclair/typebox";
import { MatrixEventIdSchema } from "./agent-host.ts";

const KnowledgeExpertActivityEventBase = {
  version: Type.Literal("1.0"),
  sourceEventId: MatrixEventIdSchema,
  sequence: Type.Integer({ minimum: 1, maximum: 1_000_000 }),
  text: Type.String({ minLength: 1, maxLength: 256 })
};

export const KnowledgeExpertActivityPhaseSchema = Type.Union([
  Type.Literal("selecting_knowledge"),
  Type.Literal("retrieving"),
  Type.Literal("reflecting"),
  Type.Literal("finalizing")
]);

export const KnowledgeExpertProgressEventSchema = Type.Object(
  {
    ...KnowledgeExpertActivityEventBase,
    type: Type.Literal("progress"),
    phase: KnowledgeExpertActivityPhaseSchema
  },
  { additionalProperties: false }
);

export const KnowledgeExpertToolEventSchema = Type.Object(
  {
    ...KnowledgeExpertActivityEventBase,
    type: Type.Literal("tool"),
    activityId: Type.String({
      minLength: 1,
      maxLength: 128,
      pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
    }),
    tool: Type.String({
      minLength: 1,
      maxLength: 64,
      pattern: "^[A-Za-z][A-Za-z0-9_]*$"
    }),
    status: Type.Union([
      Type.Literal("selected"),
      Type.Literal("started"),
      Type.Literal("completed"),
      Type.Literal("failed")
    ]),
    detail: Type.Optional(Type.String({ minLength: 1, maxLength: 256 })),
    durationMs: Type.Optional(Type.Integer({ minimum: 0, maximum: 300_000 })),
    exitCode: Type.Optional(Type.Integer({ minimum: 0, maximum: 255 })),
    purpose: Type.Optional(Type.Literal("probe")),
    evidenceCount: Type.Optional(Type.Integer({ minimum: 0, maximum: 1_000_000 }))
  },
  { additionalProperties: false }
);

export const KnowledgeExpertActivityEventSchema = Type.Union([
  KnowledgeExpertProgressEventSchema,
  KnowledgeExpertToolEventSchema
]);

export const KnowledgeExpertActivitySummarySchema = Type.Object(
  {
    events: Type.Array(KnowledgeExpertActivityEventSchema, { maxItems: 64 })
  },
  { additionalProperties: false }
);

export type KnowledgeExpertActivityPhaseV1 = Static<typeof KnowledgeExpertActivityPhaseSchema>;
export type KnowledgeExpertProgressEventV1 = Static<typeof KnowledgeExpertProgressEventSchema>;
export type KnowledgeExpertToolEventV1 = Static<typeof KnowledgeExpertToolEventSchema>;
export type KnowledgeExpertActivityEventV1 = Static<typeof KnowledgeExpertActivityEventSchema>;
export type KnowledgeExpertActivitySummaryV1 = Static<
  typeof KnowledgeExpertActivitySummarySchema
>;
